import { faSave } from "@fortawesome/free-solid-svg-icons";
import { Dispatch, SetStateAction, useState } from "react";
import UnForm from "../../../../Components/Form";
import { CadastrarTipoParcelaController } from "../../../../Controllers/Cobranca/TipoParcela/TipoParcelaController";
import { ITipoParcela } from "../../../../Interfaces/Cobranca/TipoParcela/TipoParcelaInterface";
import { AlertConfirmation } from "../../../../Tools/SweetAlerts";

interface IAdicionarTipoParcelaProps {
    setShow: Dispatch<SetStateAction<boolean>>;
    then: () => void;
}

export default function AdicionarTipoParcela(
    props: IAdicionarTipoParcelaProps
) {
    const [loading, setLoading] = useState(false);
    function handleSenhaFormSubmit(formData: ITipoParcela) {
        setLoading(true);
        CadastrarTipoParcelaController({ ...formData })
            .then((res) => {
                AlertConfirmation(
                    "Parcela Cadastrada com Sucesso",
                    "",
                    "success",
                    { cancelButtonText: false, confirmButtonText: false }
                );
            })
            .finally(() => {
                setLoading(false);
            })
            .then(props.then);
    }

    return (
        <div>
            {
                <UnForm handleSubmit={handleSenhaFormSubmit}>
                    {
                        <>
                            <div className="form-group">
                                <div className="row d-flex flex-wrap">
                                    <div className="col-12 col-lg-6 mt-2">
                                        <UnForm.Input
                                            label="Tipo"
                                            name="DS_TIPO"
                                            className="form-control placeholder-dark-50"
                                            type={"text"}
                                        />
                                    </div>
                                    <div className="col-12 col-lg-6 mt-2">
                                        <UnForm.Input
                                            name="DS_DESCRICAO"
                                            label="Descrição"
                                            className="form-control placeholder-dark-50"
                                            type={"text"}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row d-flex mt-4">
                                    <div className="col-10 col-lg-3 mt-2">
                                        <UnForm.Input
                                            name="NR_PERIODICIDADE"
                                            label="Periodicidade"
                                            type={"number"}
                                        />
                                    </div>
                                    <div className="col-10 col-lg-3 mt-2">
                                        <UnForm.Input
                                            name="MAX_PRO_SOLUTO"
                                            label="Max Pro Soluto"
                                            type={"number"}
                                        />
                                    </div>
                                    <div className="col-10 col-lg-3 mt-2">
                                        <UnForm.Input
                                            name="MAX_RENDA"
                                            label="Max Renda"
                                            type={"number"}
                                        />
                                    </div>
                                    <div className="col-10 col-lg-3 mt-2">
                                        <UnForm.Input
                                            name="MIN_RENDA"
                                            label="Min Renda"
                                            type={"number"}
                                        />
                                    </div>
                                </div>
                                <div className="d-flex row ml-4">
                                    <UnForm.Switch
                                        wrapperClassName="col-12 col-lg-4 mt-2"
                                        color="primary"
                                        label="GERAR_BOLETO"
                                        labelPosition="top"
                                        type="checkbox"
                                        name="FL_GERAR_BOLETO"
                                    />
                                    <UnForm.Switch
                                        color="primary"
                                        wrapperClassName="col-12 col-lg-4 mt-2"
                                        label="ATIVO"
                                        labelPosition="top"
                                        type="checkbox"
                                        name="FL_ATIVO"
                                    />
                                    <UnForm.Switch
                                        color="primary"
                                        wrapperClassName="col-12 col-lg-4 mt-2"
                                        label="PRO_SOLUTO"
                                        labelPosition="top"
                                        type="checkbox"
                                        name="FL_PRO_SOLUTO"
                                    />
                                    <UnForm.Switch
                                        color="primary"
                                        wrapperClassName="col-12 col-lg-4 mt-2"
                                        label="SUBSIDIO"
                                        labelPosition="top"
                                        type="checkbox"
                                        name="FL_SUBSIDIO"
                                    />
                                    <UnForm.Switch
                                        color="primary"
                                        wrapperClassName="col-12 col-lg-4 mt-2"
                                        label="FGTS"
                                        labelPosition="top"
                                        type="checkbox"
                                        name="FL_FGTS"
                                    />
                                    <UnForm.Switch
                                        wrapperClassName="col-12 col-lg-4 mt-2"
                                        color="primary"
                                        label="FINANCIAMENTO"
                                        labelPosition="top"
                                        type="checkbox"
                                        name="FL_FINANCIAMENTO"
                                    />
                                    <UnForm.Switch
                                        color="primary"
                                        wrapperClassName="col-12 col-lg-4 mt-2"
                                        label="FINANCIAMENTO_PROPRIO"
                                        labelPosition="top"
                                        type="checkbox"
                                        name="FL_FINANCIAMENTO_PROPRIO"
                                    />
                                    <UnForm.Switch
                                        color="primary"
                                        wrapperClassName="col-12 col-lg-4 mt-2"
                                        label="MENSAL"
                                        labelPosition="top"
                                        type="checkbox"
                                        name="FL_MENSAL"
                                    />
                                    <UnForm.Switch
                                        color="primary"
                                        wrapperClassName="col-12 col-lg-4 mt-2"
                                        label="SINAL"
                                        labelPosition="top"
                                        type="checkbox"
                                        name="FL_SINAL"
                                    />
                                    <UnForm.Switch
                                        color="primary"
                                        wrapperClassName="col-12 col-lg-4 mt-2"
                                        label="ENTRADA"
                                        labelPosition="top"
                                        type="checkbox"
                                        name="FL_ENTRADA"
                                    />
                                    <UnForm.Switch
                                        color="primary"
                                        wrapperClassName="col-12 col-lg-4 mt-2"
                                        label="TRIMESTRAL"
                                        labelPosition="top"
                                        type="checkbox"
                                        name="FL_TRIMESTRAL"
                                    />
                                    <UnForm.Switch
                                        color="primary"
                                        wrapperClassName="col-12 col-lg-4 mt-2"
                                        label="SEMESTRAL"
                                        labelPosition="top"
                                        type="checkbox"
                                        name="FL_SEMESTRAL"
                                    />
                                    <UnForm.Switch
                                        color="primary"
                                        wrapperClassName="col-12 col-lg-4 mt-2"
                                        label="INTERMEDIARIA"
                                        labelPosition="top"
                                        type="checkbox"
                                        name="FL_INTERMEDIARIA"
                                    />
                                    <UnForm.Switch
                                        color="primary"
                                        wrapperClassName="col-12 col-lg-4 mt-2"
                                        label="ANUAL"
                                        labelPosition="top"
                                        type="checkbox"
                                        name="FL_ANUAL"
                                    />
                                    <UnForm.Switch
                                        color="primary"
                                        wrapperClassName="col-12 col-lg-4 mt-2"
                                        label="COMISSIONAR"
                                        labelPosition="top"
                                        type="checkbox"
                                        name="FL_COMISSIONAR"
                                    />
                                    <UnForm.Switch
                                        color="primary"
                                        wrapperClassName="col-12 col-lg-4 mt-2"
                                        label="BONUS"
                                        labelPosition="top"
                                        type="checkbox"
                                        name="FL_BONUS"
                                    />
                                    <UnForm.Switch
                                        color="primary"
                                        wrapperClassName="col-12 col-lg-4 mt-2"
                                        label="PAGAMENTO_REPASSE"
                                        labelPosition="top"
                                        type="checkbox"
                                        name="FL_PAGAMENTO_REPASSE"
                                    />
                                    <UnForm.Switch
                                        color="primary"
                                        wrapperClassName="col-12 col-lg-4 mt-2"
                                        label="UNICA"
                                        labelPosition="top"
                                        type="checkbox"
                                        name="FL_UNICA"
                                    />
                                    <UnForm.Switch
                                        color="primary"
                                        wrapperClassName="col-12 col-lg-4 mt-2"
                                        label="FORA EXTRATO"
                                        labelPosition="top"
                                        type="checkbox"
                                        name="FL_FORA_EXTRATO"
                                    />
                                </div>
                            </div>
                            <UnForm.SubmitButton
                                color="success"
                                wrapperClassName="w-100 mt-8"
                                className="w-100"
                                icon={faSave}
                                loading={loading}
                                disabled={loading}
                                loadingSize={"lg"}
                            >
                                Salvar
                            </UnForm.SubmitButton>
                        </>
                    }
                </UnForm>
            }
        </div>
    );
}
